import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerifyOtpService {
  
  constructor(private httpClient: HttpClient, private router: Router, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  
  sendOtp(reciversEmail:string,otpType:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Emails/SendOTP`,{reciversEmail,otpType}).pipe(
      catchError(this.error)
    );
  }
  reSendOtp(reciversEmail:string,otpType:any): Observable<any> {
    
    return this.httpClient.post(`${this.apiUrl}/Emails/ResendOTP`,{reciversEmail,otpType}).pipe(
      catchError(this.error)
    );
  }
  verifyOtp(email:string,otp:string,otpType:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Emails/VerifyOTP`,{email,otp,otpType}).pipe(
      catchError(this.error)
    );
  }
  verifyResetpasswordOTP(email:string,otp:string,otpType:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Emails/VerifyResetPasswordOTP`,{email,otp,otpType}).pipe(
      catchError(this.error)
    );
  }
  

   // Handle Errors
   error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
}
